/**
 * @generated SignedSource<<a0828a6e5b73310d65576cf628742bd7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventConnectionOrder = "CREATED_AT" | "ORDERING_PRIORITY";
export type EventConnectionSortDirection = "ASCENDING" | "DESCENDING";
export type EventStatus = "ACTIVE" | "CLOSED" | "UPCOMING";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
export type EventQueryFilters = {
  locations?: ReadonlyArray<LocationKind> | null | undefined;
  order?: EventConnectionOrder;
  rewards?: ReadonlyArray<RewardKind> | null | undefined;
  search?: string | null | undefined;
  sortDirection?: EventConnectionSortDirection;
  status?: EventStatus | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type EventsPageSectionsFragmentPaginationQuery$variables = {
  activeFilters?: EventQueryFilters | null | undefined;
  closedFilters?: EventQueryFilters | null | undefined;
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  tutorialFilters?: EventQueryFilters | null | undefined;
  upcomingFilters?: EventQueryFilters | null | undefined;
};
export type EventsPageSectionsFragmentPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventsPageSectionsFragment">;
};
export type EventsPageSectionsFragmentPaginationQuery = {
  response: EventsPageSectionsFragmentPaginationQuery$data;
  variables: EventsPageSectionsFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "activeFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "closedFilters"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tutorialFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "upcomingFilters"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "cursor"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "host",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    (v9/*:: as any*/),
    (v10/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "RewardConnection",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RewardEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Reward",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AmountRange",
              "kind": "LinkedField",
              "name": "amount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "start",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "end",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rewards(first:1)"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "TaggableConnection",
      "kind": "LinkedField",
      "name": "tags",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TagEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Tag",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tags(first:8)"
    }
  ],
  "type": "Taggable",
  "abstractKey": "__isTaggable"
},
v14 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventCompetitionConnection",
            "kind": "LinkedField",
            "name": "competitions",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Timeline",
            "kind": "LinkedField",
            "name": "timeline",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "locationKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Location",
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v15 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "count"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventsPageSectionsFragmentPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "activeFilters",
            "variableName": "activeFilters"
          },
          {
            "kind": "Variable",
            "name": "closedFilters",
            "variableName": "closedFilters"
          },
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          {
            "kind": "Variable",
            "name": "tutorialFilters",
            "variableName": "tutorialFilters"
          },
          {
            "kind": "Variable",
            "name": "upcomingFilters",
            "variableName": "upcomingFilters"
          }
        ],
        "kind": "FragmentSpread",
        "name": "EventsPageSectionsFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventsPageSectionsFragmentPaginationQuery",
    "selections": [
      {
        "alias": "tutorial",
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "tutorialFilters"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 3
          }
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v14/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "upcoming",
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "upcomingFilters"
          },
          (v15/*:: as any*/)
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v14/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "active",
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "activeFilters"
          },
          (v15/*:: as any*/)
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v14/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": "closed",
        "args": [
          (v1/*:: as any*/),
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "closedFilters"
          },
          (v15/*:: as any*/)
        ],
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": (v14/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EventCompetition",
        "kind": "LinkedField",
        "name": "eventCompetitionPinned",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Competition",
            "kind": "LinkedField",
            "name": "competition",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionMembership",
                "kind": "LinkedField",
                "name": "membership",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "entity",
                    "plural": false,
                    "selections": [
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      (v10/*:: as any*/),
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*:: as any*/),
              (v13/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0ce6ec2f2aa6f453d98d81c6578374f",
    "id": null,
    "metadata": {},
    "name": "EventsPageSectionsFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query EventsPageSectionsFragmentPaginationQuery(\n  $activeFilters: EventQueryFilters\n  $closedFilters: EventQueryFilters\n  $count: Int = 10\n  $cursor: String\n  $tutorialFilters: EventQueryFilters\n  $upcomingFilters: EventQueryFilters\n) {\n  ...EventsPageSectionsFragment_FnCsj\n}\n\nfragment ActivityCardHostFragment on Entity {\n  __isEntity: __typename\n  username\n  ...EntityProfilePicFragment_49kWkb\n}\n\nfragment ActivityCardTagListFragment on Taggable {\n  __isTaggable: __typename\n  tags(first: 8) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment CompetitionCardFooterFragment on Competition {\n  rewards(first: 1) {\n    totalCount\n    edges {\n      node {\n        ...RewardFragment\n        id\n      }\n    }\n  }\n}\n\nfragment CompetitionCardFragment on Competition {\n  id\n  slug\n  title\n  thumbnail\n  shortDescription\n  membership {\n    id\n    entity {\n      __typename\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  host {\n    __typename\n    ...ActivityCardHostFragment\n    id\n  }\n  ...ActivityCardTagListFragment\n  ...CompetitionCardFooterFragment\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment EventCardFooterFragment on Event {\n  rewards(first: 1) {\n    totalCount\n    edges {\n      node {\n        ...RewardFragment\n        id\n      }\n    }\n  }\n}\n\nfragment EventCardFragment on Event {\n  id\n  slug\n  title\n  thumbnail\n  visibility\n  host {\n    __typename\n    ...ActivityCardHostFragment\n    id\n  }\n  competitions {\n    totalCount\n  }\n  ...EventCardFooterFragment\n  ...ActivityCardTagListFragment\n  ...EventLocationFragment\n}\n\nfragment EventLocationFragment on Event {\n  timeline {\n    timezone\n    startDate\n    endDate\n    locationKind\n    location {\n      country\n      city\n      id\n    }\n    id\n  }\n}\n\nfragment EventsCarouselFragment on EventConnection {\n  edges {\n    node {\n      id\n      ...EventCardFragment\n    }\n  }\n}\n\nfragment EventsPageSectionsFragment_FnCsj on Query {\n  tutorial: events(after: $cursor, first: 3, filters: $tutorialFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  upcoming: events(after: $cursor, first: $count, filters: $upcomingFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  active: events(after: $cursor, first: $count, filters: $activeFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  closed: events(after: $cursor, first: $count, filters: $closedFilters) {\n    totalCount\n    ...EventsCarouselFragment\n  }\n  ...TrackOfTheMonthFragment\n}\n\nfragment RewardFragment on Reward {\n  id\n  kind\n  amount {\n    start\n    end\n  }\n}\n\nfragment TrackOfTheMonthFragment on Query {\n  eventCompetitionPinned {\n    event {\n      slug\n      id\n    }\n    competition {\n      ...CompetitionCardFragment\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a0c4887acec27d2ca7a90b233c60d06";

export default node;
